import { render, staticRenderFns } from "./FlexAdminSideNav.vue?vue&type=template&id=b035dfcc&scoped=true&"
import script from "./FlexAdminSideNav.vue?vue&type=script&lang=js&"
export * from "./FlexAdminSideNav.vue?vue&type=script&lang=js&"
import style0 from "./FlexAdminSideNav.vue?vue&type=style&index=0&id=b035dfcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b035dfcc",
  null
  
)

export default component.exports